<template>
  <nuxt-link :to="link" class="link-card">
    <header class="link-card-header">
      <p class="link-card-title">
        {{ title }}
      </p>
    </header>

    <p class="link-card-description">
      {{ description }}
    </p>

    <footer class="link-card-footer">
      <LinkArrow width="24" height="24" viewBox="0 0 20 20" />
    </footer>
  </nuxt-link>
</template>

<script>
import LinkArrow from '@itbpbg/lms-components/src/assets/svg/arrow-right.svg?vue-component';

export default {
  components: {
    LinkArrow,
  },
  props: {
    title: { type: String, required: true },
    description: { type: String, required: true },
    link: { type: String, required: true },
  },
};
</script>

<style scoped lang="scss">
.link-card {
  display: flex;
  flex-direction: column;
  padding: 28px 20px;
  border-radius: 20px;
  box-shadow: 0 4px 15px 0 rgba(0, 12, 31, 0.25);
  transition: all var(--duration) ease-in;
  background-color: var(--main-light);

  &:hover {
    cursor: pointer;
    scale: 1.048;
  }

  .link-card-header .link-card-title {
    color: var(--accent-shade-1);
    font-size: 24px;
    font-weight: 500;
    line-height: 110%;
    margin: 0;
  }

  .link-card-description {
    flex-grow: 1;
    color: var(--main-dark-shade-2);
    font-size: 18px;
    line-height: 150%;
    margin: 12px 0 0;
  }

  .link-card-footer {
    display: flex;
    margin-top: 12px;

    svg {
      margin-left: auto;

      path {
        stroke: var(--accent-shade-1);
      }
    }
  }

  .link-card:hover {
    .link-card-footer {
      svg path {
        stroke: var(--accent-shade-3);
      }
    }
  }
}

@include bp($bp-laptop-tablet) {
  .link-card {
    .link-card-header .link-card-title {
      font-size: 21px;
    }

    .link-card-description {
      font-size: 16px;
    }
  }
}

@include bp($bp-mobile) {
  .link-card {
    &:hover {
      scale: 1;
    }

    .link-card-header .link-card-title {
      font-size: 18px;
    }

    .link-card-description {
      font-size: 16px;
    }
  }
}
</style>
